import Axios from "axios";

const url = '/filterSets';

const filterSetsApi = {
    get: () => {
        return Axios.get(url);
    },
    post: (params) => {
        return Axios.post(url, params);
    },
    patch: (id, params) => {
        return Axios.patch(`${url}/${id}`, params);
    },
    delete: (id) => {
        return Axios.delete(`${url}/${id}`);
    }
};

export default filterSetsApi;